<main>
  <ng-container *transloco="let t">
    <section class="wallpaper"></section>

    <section class="login">
      <div style="width: 100%">
        <button
          type="button"
          (click)="back()"
          class="back-arrow-icon icon icon-m back-btn"
          [attr.aria-label]="t('Back')"
        ></button>
      </div>

      <div
        style="
          display: flex;
          flex-direction: column;
          max-width: 360px;
          justify-content: center;
          align-items: center;
        "
      >
        <div class="logo-wrapper">
          <p class="logo"></p>
        </div>

        @if (store.submitted()) {
          <div class="state-wrapper">
            <div class="icon-circle success-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12l1.41-1.41L10 15.17l8.59-8.59L20 8l-10 10z"
                  fill="#ffffff"
                />
              </svg>
            </div>
            <h2 class="state-title">{{ t('Check your email') }}</h2>
            <p class="description">
              {{ t('We have sent a password reset link to {{email}}. Please open
              the email and confirm the link, then return to set a new
              password.', { email: store.submittedEmail() }) }}
            </p>
            <p class="description">
              {{
                t(
                  "Didn't receive the email? Check your spam folder or try again."
                )
              }}
            </p>
            <div class="state-actions">
              <button
                mat-flat-button
                class="primary-btn"
                type="button"
                (click)="backToLogin()"
              >
                {{ t('Back to login') }}
              </button>
              <button
                mat-stroked-button
                type="button"
                class="secondary-btn"
                (click)="resend()"
              >
                {{ t('Send again') }}
              </button>
            </div>
          </div>
        } @else {
          <div class="welcome-text">
            <h2>{{ t('Reset Passwords') }}</h2>
            <p>
              {{
                t(
                  'Choose the account type (clinic owner, clinic, or manager), then enter the email used for that account.'
                )
              }}
            </p>
          </div>
          <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="sm:mx-auto sm:w-full sm:max-w-sm flex flex-col gap-4">
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>{{ t('Account type') }}</mat-label>
                <mat-select formControlName="accountType">
                  @for (type of portalAccountTypes; track type.value) {
                    <mat-option [value]="type.value">{{
                      t(type.labelKey)
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <div style="width: 100%">
                <label
                  for="email"
                  class="block text-sm font-medium leading-6 text-gray-900"
                  >{{ t('Email') }}</label
                >
                <div class="relative mt-2 rounded-md shadow-sm">
                  <div
                    class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
                  >
                    <span class="icon email-icon"></span>
                  </div>
                  <input
                    formControlName="email"
                    matInput
                    id="email"
                    type="email"
                    class="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>

                <div style="height: 24px; margin-bottom: 4px">
                  @if (form.controls['email'].hasError('pattern')) {
                    <mat-error>
                      {{ t('Enter valid email') }}
                    </mat-error>
                  }
                </div>
              </div>

              <div>
                <button
                  mat-flat-button
                  class="primary-btn"
                  type="submit"
                  [disabled]="form.invalid || store.status() === status.Loading"
                >
                  @if (store.status() !== status.Loading) {
                    {{ t('Submit') }}
                  } @else {
                    <span
                      class="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"
                    ></span>
                    {{ t('Submitting...') }}
                  }
                </button>
              </div>
            </div>
          </form>
        }
      </div>

      <div></div>
    </section>
  </ng-container>
</main>
